import React, { Component } from 'react';
import Analytics from 'APP_ROOT/services/analytics';
import lsUtil from '../../../common/lsUtil';
import Events from '../../../common/events';
import { strings } from '../../../../localization';
import ChangePasswordModal from '../changePasswordModal';
import BillingAndPaymentsSection from '../BillingAndPaymentsSection';
import RavenInviteModal from '../ravenInviteModal';
import Themes from '../Settings/Themes';
import UnitOfMeasure from 'APP_ROOT/components/pages/account/Settings/UnitOfMeasure';
import Language from 'APP_ROOT/components/pages/account/Settings/Language';
import { accountHasBilling } from '../../../common/billing';
import Protected from '../../../common/protected';

export default class ProfilePage extends Component {

    constructor(props) {

        super(props);

        this.state = {
            loading: true,
            changePasswordModalOpen: false,
            changePasswordSuccess: null,
            changePasswordResponseMessage: null,
            deactivateRavenModalIndex: null,
            recurlyPricing: null,
        }
    }

    componentDidMount() {
        Analytics.pageView();
        if (!this.props.ravens) this.props.getUserData(this.getInvite);
        else this.getInvite();

        this.putFocusOnBillingSection();
    }

    putFocusOnBillingSection = () => {
        // Check if the URL has a hash
        if (window.location.hash) {
            // Use a try-catch block for safety
            try {
                const element = document.querySelector(window.location.hash);
                if (element) {
                    // Scroll to the element
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            } catch (e) {
                console.error('Could not scroll to element:', e);
            }
        }
    }

    getInvite = () => {
        try {
            var invite = JSON.parse(lsUtil.getLocalStorage().getItem('raven.invite'));
            this.setState({ invite: invite });
        } catch (e) {
            console.error(e);
        }
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    onChangePasswordSuccess = (e) => {

        console.log(e);
        this.setState({
            changePasswordModalOpen: false,
            changePasswordSuccess: true,
            changePasswordResponseMessage: strings.formatString(strings.reset_pw_success)
        });

        document.documentElement.classList.remove("no-scroll");
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    openChangePasswordModal = (e) => {

        e.preventDefault();
        document.documentElement.classList.add("no-scroll");
        this.setState({
            changePasswordModalOpen: true
        });
    }

    closeChangePasswordModal = (e) => {

        e.preventDefault();
        document.documentElement.classList.remove("no-scroll");
        this.setState({
            changePasswordModalOpen: false
        });
    }

    renderAccountGeneralSection() {

        var changePasswordMessage = null;
        if (this.state.changePasswordSuccess === false) {
            changePasswordMessage = <p className="error-message no-margin"><i className="material-icons">error</i><span>{this.state.changePasswordResponseMessage}</span></p>;
        } else if (this.state.changePasswordSuccess === true) {
            changePasswordMessage = <p className="success-message no-margin"><i className="material-icons">check_circle</i><span>{this.state.changePasswordResponseMessage}</span></p>;
        }    

        return (
            <div className="row">
                <div className="col-8">
                    <h1 className="d-inline-block">{strings.formatString(strings.account_details_title)}</h1>
                </div>
                <div className="col-4">
                    <a className="btn btn-header" onClick={this.props.onLogout} href="">{strings.formatString(strings.sign_out_title)}</a>
                </div>

                <div className="col-12"><h2>{strings.formatString(strings.account_user_settings)}</h2></div>

                <div className="col-12">
                    <div className="settings-section">
                        <div>
                            <h3>{strings.account_credentials_header}</h3>
                            <div>{strings.account_credentials_description}</div>
                            <div className='setting-group-horiz'>
                                <div className='setting-group'>
                                    <div className="form">
                                        <div>
                                            <label htmlFor="">{strings.formatString(strings.sign_in_email)}</label>
                                            <p>{this.props.user.email}</p>
                                        </div>

                                        <div>
                                            <label>{strings.formatString(strings.sign_in_password)}</label>
                                            <p>****** <a className="btn btn-outline-blue btn-sm" onClick={this.openChangePasswordModal}><i className="material-icons">edit</i>{strings.formatString(strings.btn_title_change)}</a></p>
                                            {changePasswordMessage}
                                            <ChangePasswordModal accountPage={this} 
                                                onChangePasswordSuccess={this.onChangePasswordSuccess} 
                                                oldPasswordRequired={true}
                                                acceptTermsRequired={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.features && this.props.features.language_selection ?
                        <div className="settings-section">
                            <Language stage={this.props.user.stage} />
                        </div>
                    :
                        null
                    }
                    {this.props.features && this.props.features.theme_selection ?
                        <div className="settings-section">
                            <Themes applyThemeChange={this.onColourThemeChange} features={this.props.features} />
                        </div>
                    :
                        null
                    }
                    <div className="settings-section">
                        <UnitOfMeasure stage={this.props.user.stage} />
                    </div>
                </div>

            </div>
        );
    }

    render() {

        // dont render billing section if feature flag is off or if channelId is not supported
        const billingRenderingGate = this.props.features?.show_billing && accountHasBilling(this.props.accountDetails);

        return (
            <div id="profilePage" className="container account-page">

                    {this.renderAccountGeneralSection()}

                    <Protected resource="billing" action="read" gate={billingRenderingGate} showNotFound={false}>
                        <BillingAndPaymentsSection {...this.props} />
                    </Protected>

                    <RavenInviteModal currentUserEmail={this.props.user.email} user={this.props.user} />
            </div>
        );
    }
}